module.exports = __webpack_public_path__ + "a2e2376e8cb77ed42903743ea99ef397.png";